import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useBrandList = (sendById) => {
    const { brands } = useSelector(state => ({
        brands: state.Brands.brands,
      }));
    const [brandList, setBrandList] = useState([])
    useEffect(() => {
        const brandList = brands.map(e => ({ label: e.name, value: sendById ? e.id : e.name }));
        setBrandList(brandList)
    }, [brands])
    return { brandList }
}

export default useBrandList